<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col">
            <h3 class="page-title">Lấy dữ liệu trang vàng</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="index.html">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">Lấy dữ liệu trang vàng</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0">
            <div class="card-body">
              <form @submit.prevent="handleSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Link:</label>
                      <input type="text" class="form-control" v-model="link" />
                    </div>
                    <div class="form-group">
                      <label>Trang bắt đầu:</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="startPage"
                      />
                    </div>
                    <div class="form-group">
                      <label>Trang kết thúc:</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="endPage"
                      />
                    </div>
                    <div class="form-group">
                      <label>Loại ngành nghề</label>
                      <select v-model="selectedIndustryId" class="form-control">
                        <option :value="null" disabled>Chọn ngành nghề</option>
                        <option
                          v-for="industry in industries"
                          :key="industry.id"
                          :value="industry.id"
                        >
                          {{ industry.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-primary">
                    Lấy dữ liệu
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import api from "../api"; // axios instance
import axios from "axios"; // thêm axios nếu cần gửi ngoài api backend
import { useToast } from "vue-toastification";

const industries = ref([]);
const selectedIndustryId = ref(null);
const link = ref("");
const startPage = ref(1);
const endPage = ref(1);

const toast = useToast();

const fetchIndustries = async () => {
  try {
    const response = await api.get("/api/industries/all");
    industries.value = response.data; // trả về List<Industry>
  } catch (error) {
    console.error("Lỗi khi tải danh sách ngành nghề:", error);
    toast.error("Lỗi khi tải danh sách ngành nghề.");
  }
};

const handleSubmit = async () => {
  const payload = {
    link: link.value,
    startPage: startPage.value,
    endPage: endPage.value,
    industryId: selectedIndustryId.value,
  };

  try {
    const res = await axios.post(
      // 'https://n8n.thepminhtien.com/webhook/701c3464-69b2-4425-8760-88d309f31fdf', // production
      'https://n8n.thepminhtien.com/webhook/f812b977-b030-4f12-aa8d-6c838cf4dd75', // local
      //process.env.VUE_APP_WEBHOOK_LAYDULIEUTRANGVANG_URL,
      payload
    );
    console.log("Webhook response:", res.data);
    toast.success("Đã gửi dữ liệu tới n8n thành công!");
  } catch (error) {
    console.error("Lỗi gửi webhook:", error);
    toast.error("Không thể gửi dữ liệu tới n8n.");
  }
};

onMounted(fetchIndustries);
</script>
